import { useModal } from '@/storybook/modal/useModal';
import LimitsModal from './LimitsModal.vue';
import type { LimitsModalProps } from './types';

let isLimitsModalOpen = false;

export const useLimitsModal = () => {
  const showLimitsModal = (props?: LimitsModalProps) => {
    if (isLimitsModalOpen) {
      return;
    }

    const { open, close } = useModal(LimitsModal, {
      modalProps: {
        ...props,
      },
      customClose: () => {
        isLimitsModalOpen = false;
        if (props?.onClose) {
          props.onClose();
        }
        close();
      },
      onClickOutside: () => {
        isLimitsModalOpen = false;
        if (props?.onClose) {
          props.onClose();
        }
        close();
      },
      dataTestid: 'limits-modal',
      clickToClose: false,
      hideClose: true,
    });

    isLimitsModalOpen = true;
    return open();
  };

  return { showLimitsModal };
};
